const AreaUnitType = Object.freeze({
  SQUARE_MILLIMETER: "mm²",
  SQUARE_CENTIMETER: "cm²",
  SQUARE_DECIMETER: "dm²",
  SQUARE_METER: "m²",
  SQUARE_DEKAMETER: "dam²",
  SQUARE_HECTOMETER: "hm²",
  SQUARE_KILOMETER: "km²",
  SQUARE_INCH: "in²",
  SQUARE_FOOT: "ft²",
  SQUARE_YARD: "yd²",
  SQUARE_MILE: "mi²",
  ACRE: "ac"
});
export default AreaUnitType;